import { render, staticRenderFns } from "./PatientData.html?vue&type=template&id=74b700cb&external"
import script from "./PatientData.vue?vue&type=script&lang=js"
export * from "./PatientData.vue?vue&type=script&lang=js"
import style0 from "./PatientData.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports